import router from "./router";
import store from "./store";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken, setToken } from "@/utils/auth"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login", "/auth-redirect"]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);
  // determine whether the user has logged in
  const hasToken = getToken();
  if (hasToken) {
    const hasRoles = store.getters.routeStatus;
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      if (hasRoles) {
        next({ path: "/" });
      } else {
        next({ path: "/changeRole" });
      }
      NProgress.done(); // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // 菜单管理调通后，这里注释
      // next()
      // return
      // determine whether the user has obtained his permission roles through getInfo
      // const hasRoles = store.getters.permission_routes && store.getters.permission_routes.length > 0
      console.log(store.getters.permission_routes);
      if (hasRoles) {
        if (
          store.getters.permission_routes &&
          store.getters.permission_routes.length > 0
        ) {
          next();
        } else {
          if (to.path != "/") {
            next({ path: "/" });
            NProgress.done();
          } else {
            next();
          }
        }
      } else {
        if (to.path == "/changeRole") {
          next();
          NProgress.done();
        } else {
          store.dispatch("user/getInfo").then((rs) => {
            if (rs.data.isSingleRole && rs.data.roles.length == 0) {
              next({ path: "/changeRole" });
              NProgress.done();
            } else {
              // generate accessible routes map based on roles
              store
                .dispatch("permission/generateRoutes")
                .then((res) => {
                  const accessRoutes = res;
                  // dynamically add accessible routes
                  router.addRoutes(accessRoutes);
                  router.addRoutes([
                    {
                      path: "*",
                      component: () => import("@/views/error-page/404"),
                      hidden: true,
                    },
                  ]);
                  // hack method to ensure that addRoutes is complete
                  // set the replace: true, so the navigation will not leave a history record
                  next({ ...to, replace: true });
                })
                .catch((error) => {
                  // remove token and go to login page to re-login
                  store.dispatch("user/resetToken").then((res) => {
                    next(`/login?redirect=${to.fullPath}`);
                  });
                });
            }
          });
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      if (to.path === "/") {
        if (to?.query?.token) {
          store.commit("SET_TOKEN", to.query.token);
          // commit('SET_USER_ID',data.userid)
          debugger;
          setToken(to.query.token);
          store
            .dispatch("user/getInfo")
            .then((rs) => {
              debugger;
              if (rs.data.isSingleRole && rs.data.roles.length == 0) {
                next({ path: "/changeRole" });
                NProgress.done();
              } else {
                // generate accessible routes map based on roles
                debugger;
                store
                  .dispatch("permission/generateRoutes")
                  .then((res) => {
                    const accessRoutes = res;
                    // dynamically add accessible routes
                    router.addRoutes(accessRoutes);
                    router.addRoutes([
                      {
                        path: "*",
                        component: () => import("@/views/error-page/404"),
                        hidden: true,
                      },
                    ]);
                    // hack method to ensure that addRoutes is complete
                    // set the replace: true, so the navigation will not leave a history record
                    next("/");
                  })
                  .catch((error) => {
                    window.location.href = location.origin + "/login";
                  });
              }
            })
            .catch(() => {
              window.location.href = location.origin + "/login";
            });
        } else {
          window.location.href = location.origin + "/login";
        }
      }
      // window.location.href = window.location.origin + "/login";
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
